import { Component } from '@angular/core';
import { Router, Event, NavigationEnd } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subject, takeUntil } from 'rxjs';
import { AppState } from './app.reducer';
import { setNavbarState } from './app.actions';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  title = 'ui';

  private readonly unsubscribe$ = new Subject();

  constructor(private router: Router, private store: Store<{ app: AppState }>) {
    this.router.events
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(this.routeChangeHandler);
  }

  ngOnDestory() {
    this.unsubscribe$.complete();
  }

  routeChangeHandler = (event: Event) => {
    if (event instanceof NavigationEnd) {
      this.store.dispatch(setNavbarState({ navBarState: event.url }));
    }
  };
}
